import {processApiRequest} from '../../Common/saga';
import * as ACTION from './constants';
import apiService from '../apiService';

export function* fetchOrderPackages(action) {
    yield processApiRequest(ACTION.FETCH_ORDER_PACKAGES, () => apiService.getOrderPackages(action.payload.orderId), action.payload);
}
